export default __webpack_public_path__ + "static/media/Casual.023a76f3.svg";